import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify, {
    iconfont: 'mdi'
})

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#E6332A",
                secondary: "#0099DB",
                accent: "#000000",
            },
        },
    },
})